/**
 * Content Messages
 *
 * This contains all the text for the Content component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.knowledge.sidebar';

export default defineMessages({
  content: {
    id: `${scope}.content`,
    defaultMessage: 'Content',
  },
});
